import React, { useState, useEffect } from "react";
import { sbaAxios } from '../utils/sbaAxios';
import { getRoles, insertUpdateRole, deleteRole, getRoleAttributes, getDefaultPage } from "../../config/apiConfig";
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { ToastContainer, toast } from 'react-toastify';
import { SBADropDown } from "../UiComponents/SBADropDown";
import { SBAAGgrid } from '../UiComponents/SBAAGgrid';
export const Roles = () => {

    const [rolesData, setRolesData] = useState([]);
    const [attributeData, setattributeData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [drawerAttribute, setDrawerAttribute] = useState();
    const [newRoleId, setNewRoleId] = useState("");
    const [newRoleName, setNewRoleName] = useState("");

    
    const [defaultPage,setDefaultPage]=useState(null);
    const [availableDefPage,setAvailableDefpage]=useState([]);
    const [isNotificationsChecked, setIsNotificationsChecked] = useState(false);

    const [showDrawer, setshowDrawer] = useState(false);
    const [setRender, render] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [RoleId, setRoleId] = useState();
    const ColumnFilteroption = false;
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        setshowDrawer(true);
        setDrawerAttribute(undefined);
        setNewRoleId("");
        setNewRoleName("");
        setDefaultPage(undefined);
    };

    const handleAddRole = async () => {
        if(!newRoleName || !drawerAttribute || !defaultPage)
        {
            toast.warning("Please Fill the All the Fields", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
        else {
            const data = {
                "RoleId": newRoleId == "" ? 0 : newRoleId,
                "RoleName": newRoleName,
                "attributeId": drawerAttribute.RoleAttributeId,
                "attributeName": drawerAttribute.AttributeName,
                "defaultPageId":defaultPage.PageID,
                "defaultPageName":defaultPage.PageName,
                "IsNotificationsEnabled":isNotificationsChecked
            }
            try {
                const response = await sbaAxios({
                    url: `${insertUpdateRole}`,
                    method: 'post',
                    data: data,
                })
                if (response === -9444) {
                    toast.warning("Role Name Already Exists", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                }
                else if (response > 0) {
                    console.log(response,"Role")
                    closeModal();
                    toast.success("Role Saved Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })

                    rolesListData();
                    setIsNotificationsChecked(false);
                    setRender(!render);
                }
            } catch (error) {
                console.error("Error updating role:", error);
                setIsNotificationsChecked(false);
            }
        }

    };

    const closeModal = () => {
        setIsModalOpen(false);
        setshowDrawer(false);
        setShowModal(false);
        setIsNotificationsChecked(false);
    };

    const EditButtonRenderer = (props) => {
        const roleData = props.data;
        const handleEditClick = () => {
            onEditButtonClick(roleData);
        };

        return (
            <div className="actions-cell">
                <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={handleEditClick}></i>
            </div>)
    };

    const onEditButtonClick = (roleData) => {
        console.log(roleData,'roleData')
        setIsModalOpen(!isModalOpen);
        setshowDrawer(true);
        setNewRoleId(roleData.RoleId);
        setNewRoleName(roleData.RoleName);
        setDrawerAttribute({ RoleAttributeId: roleData.AttributeId, AttributeName: roleData.AttributeName });
        setDefaultPage({PageID:roleData.DefaultPageId,PageName: roleData.DefaultPageName});
        setIsNotificationsChecked(roleData.IsNotificationsEnabled)
    };

    const DeleteButtonRenderer = (props) => {
        const roleId = props.data.RoleId;
        const handleDeleteClick = () => {
            setShowModal(true);
            setRoleId(roleId);
        };

        return (
            <div className="actions-cell">
                <i className="fas fa-trash" style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
            </div>
        );
    };

    const onDeleteButtonClick = () => {
        setShowModal(false);
        sbaAxios({
            url: `${deleteRole}${RoleId}`,
            method: 'get',
        }).then(response => {
            if ((response === -4444) || (response === -3333)) {
                closeModal();
                toast.error("Delete Failed, Menu Mapped with this Tenant", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else if (response === -3333) {
                closeModal();
                toast.error("Delete Failed, Users Mapped with this Tenant", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else {
                closeModal();
                toast.success("Role Delete Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                setTimeout(() => {
                    rolesListData();

                }, 100);

            }

        })
            .catch(error => {
                console.error('Error deleting data:', error);
            });
    };

    const listofRolesColumnDefs = [
        { headerName: "Role Name", field: "RoleName" },
        { headerName: "Role Attribute", field: "AttributeName" },
        { headerName: "page ID", field: "DefaultPageId",hide:true},
        { headerName: "Page Name", field: "DefaultPageName" ,hide:true},
        {
            headerName: "Edit",
            field: "Edit",
            cellRenderer: EditButtonRenderer,
            maxWidth: 80,
            resizable:true
        },
        {
            headerName: "Delete",
            field: "Delete",
            maxWidth: 100,
            cellRenderer: DeleteButtonRenderer,
            resizable:true
        },
    ];

    useEffect(() => {
        rolesListData();
        RoleAttributes();
        getDefaultPageList();
    }, []);

    const rolesListData = async () => {
        try {
            const response = await sbaAxios({
                url: `${getRoles}`,
                method: 'get',
            })
            const data = response;
            setRolesData(data);
            console.log(data,'data');
        } catch (error) {
            console.error("Error fetching rolesListData from API:", error);
        }
    };
    const RoleAttributes = async () => {
        try {
            const response = await sbaAxios({
                url: `${getRoleAttributes}`,
                method: 'get',
            })
            const data = response;
            console.log(data,'attribute')
            setattributeData(data);
        } catch (error) {
            console.error("Error fetching RoleAttributes from API:", error);
        }
    };
    const getDefaultPageList=async()=>{
        try {
            const response = await sbaAxios({
                url: `${getDefaultPage}`,
                method: 'get',
            })
            const data = response;
            setAvailableDefpage(data);
        } catch (error) {
            console.error("Error fetching RoleAttributes from API:", error);
        }
    }
    const AttributeDropDownChange = (e) => {
        console.log(e.value)
        setDrawerAttribute(e.value);
    }
    const DefPageDDChng=(e)=>{
        console.log(e.value)
        setDefaultPage(e.value);
    }
    return (
        <>
            <div className="row flex-wrap">
                <div className="header-container m-2 fs-12 col-lg-6">
                    <b> Available Roles </b>
                    <button className="p-sm-btn mx-1" onClick={toggleModal}>
                        <i className="fa-solid fa-plus" /> Add
                    </button>
                </div>
                <div className="ag-theme-alpine m-1 col-lg-6" style={{ height: 550 }}>
                    {SBAAGgrid(listofRolesColumnDefs, rolesData, ColumnFilteroption)}
                </div>
            </div>
            <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Add / Update Role'}>
                <div>
                    <div>
                        <label className="header-container m-1"><b>Role Name</b></label>
                        <div >
                            <input
                                className="form-control w-65"
                                type="text"
                                value={newRoleName}
                                onChange={(e) => setNewRoleName(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="header-container m-1"><b> Attribute Name</b></label>
                            <div>
                                <SBADropDown data={attributeData} textField={'AttributeName'} valueField={'RoleAttributeId'}
                                    popupSettings={{ className: 'modalDD' }} value={drawerAttribute}
                                    onChange={AttributeDropDownChange}
                                />
                            </div>
                        </div>
                        <div>
                            <label className="header-container m-1"><b> Default Page Name</b></label>
                            <div>
                                <SBADropDown data={availableDefPage} textField={'PageName'} valueField={'PageID'}
                                    popupSettings={{ className: 'modalDD' }} value={defaultPage}
                                    onChange={DefPageDDChng}
                                />
                            </div>
                        </div>
                        <div>
                            <label className="header-container m-1"><b> Enable Notifications:</b></label>
                            <div>
                                <input type="checkbox" checked={isNotificationsChecked} onChange={()=>setIsNotificationsChecked((prev)=>!prev)}></input>
                            </div>
                        </div>
                        <div className="mt-4">
                            <button className="s-sm-btn mx-1" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="p-sm-btn mx-1" onClick={()=>handleAddRole()}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </SBADrawer>
            {<Modal show={showModal}  >
                <Modal.Header closeButton onClick={closeModal}>
                    <Modal.Title>Do you want to delete the selected User?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>The selected User will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={onDeleteButtonClick} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>}
        </>
    );
};
